import React, { Component } from 'react';
import moment from 'moment';
import { Tooltip } from "antd";
// import DoWnDropdown from '../../../components/AuthUsers/AuthorizationDetails/DoWnDropdown.png';
// import DropdownUp from '../../../components/AuthUsers/AuthorizationDetails/DropdownUp.png';

class ClaimNotesTab extends Component {
    constructor(props) {
        super(props)

        this.state = {
            months: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ],
            // summaryFilter: true,
            summaryFilter: false,
            expandedRowId: null,
            expandedRow : null,
        }
    }

    arrowDirectionUp = (id, value) => {
        this.handleRowClick(id);
        this.setState({
            expandedRowId: id,
            summaryFilter: value,

        })
    }

    arrowDirectionDown = (id, value) => {
        this.handleRowClick(id);
        this.setState({
            expandedRowId: id,
            summaryFilter: value,

        })
    }

    handleRowClick = (rowId) => {

        const currentExpandedRow = this.state.expandedRow;
        this.setState({ expandedRow: (rowId === currentExpandedRow) ? null : rowId })
    }

    renderItem = (item) => {

        const itemRows = [
            <tr key={item.notesId}>
                <td style={{ width: "150px" }}>
                    <Tooltip placement="top" title={`${this.state.months[new Date(item.createdDate).getMonth()]} ${new Date(item.createdDate).getDate()}, ${new Date(item.createdDate).getFullYear()}`}>
                        {this.state.months[new Date(item.createdDate).getMonth()]}
                        {new Date(item.createdDate).getDate()},
                        {new Date(item.createdDate).getFullYear()}
                    </Tooltip>
                </td>
                <td>
                    <Tooltip placement="top" title={item.title}>
                        {item.title}
                    </Tooltip>
                </td>
                <td>
                    <Tooltip placement="top" title={item.category}>
                        {item.category}
                    </Tooltip>
                </td>
                <td>
                    <Tooltip placement="top" title={item.createdBy} >
                        {item.createdBy}
                    </Tooltip>
                </td>
                <td>
                    <Tooltip placement="top" title={item.description} >
                        {item.description}
                    </Tooltip>
                </td>
                <td style={{ cursor: "pointer" }}>

                    {
                        (item.notesId === this.state.expandedRowId && this.state.summaryFilter === true) ?
                            <div onClick={() => this.arrowDirectionUp(item.notesId, false)} style={{ color: "#4C83E1", textDecoration: "underline", textAlign: "center" }}><span>Close </span></div> :
                            <div onClick={() => this.arrowDirectionDown(item.notesId, true)} style={{ color: "#4C83E1", textDecoration: "underline", textAlign: "center" }}><span>View</span></div>}
                </td>
            </tr>
        ];

        if (this.state.expandedRow === item.notesId) {
            itemRows.push(
                <table>
                <div>
                    <span className="claimNoteDesc">Description: </span>
                    {item.description}
                </div>
            </table>
            );
        }
        return itemRows;
    }

    render() {

        let allNotesRows = [];
        this.props.notesData.map((item, index) => {
            item.notesId = index + 1;
            const perNoteRows = this.renderItem(item);
            allNotesRows = allNotesRows.concat(perNoteRows);
        });

        return (
            <div className="claimsNoteBg">
                {this.props.notesData.length > 0 ? <div className="memRepTableDiv claimsNoteTablePadding">
                    <div className="claimsNotesTotal">Total Note: {this.props.notesData.length < 10 ? `0${this.props.notesData.length}` : this.props.notesData.length}</div>
                    <table className="claimNotesTab" style={{ border: "0px", boxShadow: "0px" }}>
                        <thead className="removeHeaderCss" >
                            <tr>
                                <th>Created Date</th>
                                <th>Title</th>
                                <th>Category</th>
                                <th>Created By</th>
                                <th>Description</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody className="tableBody">
                            {allNotesRows}
                        </tbody>
                    </table>
                </div> :

                    <div className='mt-5 mb-5 h5 d-flex justify-content-center'>
                        <span>No Record Found !</span>
                    </div>
                }

            </div>
        )
    }
}

export default ClaimNotesTab
